// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Reviews from '../components/Reviews';
import {actions as ReviewsAction} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    paginationReviews: state.reviews.paginationReviews,
    paginationReviewsPending: state.reviews.paginationReviewsPending,
    isFetchingPendingReviews: state.reviews.isFetchingPendingReviews,
    isFetchingReviews: state.reviews.isFetchingReviews,
    reviews: state.reviews.reviews,
    pendingReviews: state.reviews.pendingReviews,
    store: state.store.store,
    isFetchingAverage: state.reviews.isFetchingAverage,
    average: state.reviews.average,
    user: state.auth.user,
    currency: state.currency.currency,
    enableReviewSuccess: state.reviews.enableReviewSuccess,
    disableReviewSuccess: state.reviews.disableReviewSuccess,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ReviewsAction,
      },
      dispatch
    )
)(Reviews);
